var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-pagination',{staticClass:"mt-3",attrs:{"length":_vm.totalPages},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})}
var staticRenderFns = []

export { render, staticRenderFns }